@if (errors.length > 0) {
  <div class="errors">
    {{globals.i18n.errors.header}}
  </div>
}
@for (error of errors; track error) {
  <ul class="errors">
    {{error}}
  </ul>
}

@for (message of messages; track message) {
  <ul class="messages">
    {{message}}
  </ul>
}
